import { create } from 'zustand';
import { devtools } from "zustand/middleware";
import type { IServicesStore } from '../types/zustand/services';

export const useServicesStore = create<IServicesStore>()(
  devtools(
    (set) => ({
      isDigestEnabled: undefined,
      setIsDigestEnabled: (isDigestEnabled) => set(() => ({ isDigestEnabled }),
        undefined,
        'ServicesStore/setIsDigestEnabled'
      ),

      isMerchantStatementEnabled: undefined,
      setIsMerchantStatementEnabled: (isMerchantStatementEnabled) => set(() => ({ isMerchantStatementEnabled }),
        undefined,
        'ServicesStore/setIsMerchantStatementEnabled'
      ),
        isLoading: false,

      setIsLoading: (isLoading) => set(() => ({ isLoading }),
        undefined,
        'ServicesStore/setIsLoading'
      ),
    } as IServicesStore),
    { name: 'ServicesStore' }
  )
);
